module.exports = __webpack_public_path__ + "static/media/transparent.effd80ef.png";